var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import useModal from '@delangle/use-modal';
import * as React from 'react';
import { TogglePanelContext } from '../TogglePanel/TogglePanel.context';
var FloatingPanelContext = React.createContext(null);
export var withFloatingPanelBehavior = function (defaultModalConfig) {
    if (defaultModalConfig === void 0) { defaultModalConfig = {}; }
    return function (WrappedComponent) {
        var Field = React.forwardRef(function (_a, ref) {
            var children = _a.children, open = _a.open, onClose = _a.onClose, persistent = _a.persistent, value = _a.value, animated = _a.animated, rest = __rest(_a, ["children", "open", "onClose", "persistent", "value", "animated"]);
            var modal = useModal({
                ref: ref,
                open: open,
                onClose: onClose,
                value: value,
                persistent: persistent !== null && persistent !== void 0 ? persistent : defaultModalConfig.persistent,
                animated: animated !== null && animated !== void 0 ? animated : defaultModalConfig.animated,
                animationDuration: defaultModalConfig.animationDuration,
            });
            var parentFloatingPanelRef = React.useContext(FloatingPanelContext);
            var props = __assign({ modal: modal, parentFloatingPanelRef: parentFloatingPanelRef }, rest);
            return (React.createElement(TogglePanelContext.Provider, { value: modal },
                React.createElement(FloatingPanelContext.Provider, { value: modal.ref },
                    React.createElement(WrappedComponent, __assign({}, props, { ref: modal.ref }), children))));
        });
        return Field;
    };
};
//# sourceMappingURL=withFloatingPanelBehavior.js.map